import { IComponentOptions } from "angular";
import { ContractDetailComponentController } from "../../../../../../../Contract/shared/controllers/contractDetailComponentController";

export const vsComponentName = "masterAgreementDetailComponent";

export const gamingContractMasterAgreementDetailComponentOptions: IComponentOptions =
  {
    controller: ContractDetailComponentController,
    controllerAs: "masterAgreementDetailController",
    template: require("!html-loader!./index.html").default,
    bindings: {
      contractType: "<",
      contract: "<",
    },
  };
